import React from "react";
import FormLayout from '../FormLayout';
import TextField from './TextField';
import { Field } from 'redux-form';
import moment from 'moment';
import DateTimePicker from '../../components/DateTimePicker/DateTimePicker';
import { resolveDatePickerProps } from '../../components/DateTimePicker/datePickerConstraints';

/** Class representing a PDF layout custom text field. */
class DatetimeField extends TextField {

    constructor(properties) {
        super({
            ...(DatetimeField.getDefaultOptions()),
            ...properties,
        });

        this.type = FormLayout.DATETIME;
    }

    /**
     * Get this field default options
     */
    static getDefaultOptions() {
        const properties = super.getDefaultOptions();

        properties.with_time = true;

        return properties;
    }

    /**
     * Return the list of options this field handles
     */
    getHandledOptions() {
        return super.getHandledOptions()
            .filter(o => o !== FormLayout.OPTION_PLACEHOLDER)
            .concat([
                FormLayout.OPTION_WITH_TIME,
                FormLayout.OPTION_DATE_CONSTRAINT,
                FormLayout.OPTION_DATE_MIN,
                FormLayout.OPTION_DATE_MAX,
                FormLayout.OPTION_OPEN_AT_YEARS_AGO,
            ]);
    }

    getDateConstraint() {
        return this.content?.date_constraint ?? '';
    }

    /**
     * Return this field preview input
     *
     * @param {Object} props with at least the following properties:
     *                 - {Bool} inEdition
     *                 - {Bool} inPreview
     *                 - {String} lang
     *                 - {Object} setting
     *                 - {Any} value
     *                 - {Object} resources
     */
    getInput(context) {
        const pickerProps = resolveDatePickerProps({
            constraint: this.content?.date_constraint,
            withTime: !!this.with_time,
            content: this.content,
            phases: context?.resources?.phases,
            fieldName: this.name,
        });

        return (
            <Field
                component={DateTimePicker}
                name={this.reduxFieldName(context)}
                required={this.htmlRequired(context)}
                className="form-control"
                {...pickerProps}
            />
        );
    }

    /**
     * Render a value
     *
     * @param {Any} value
     * @param {Object} context: an object with the following keys:
     *                   - lang (mandatory)
     *                   - t (mandatory)
     *                   - format (optional)
     *
     * @return {String}
     */
    renderValue(value, context) {
        const format = context.format || (!!this.with_time ? 'LLL' : 'LL');

        return moment(value).format(format);
    }

    /**
     * Return the icon to use on the editor button
     */
    getIcon() {
        return 'calendar-o';
    }
}

export default DatetimeField;
